<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" style="margin-left: 20px;" label-position="left">
          <el-form-item label="请选择Bucket:">
            <el-select v-model="bucketpath" filterable placeholder="请选择Bucket" @change="bucketchange">
              <el-option
                v-for="item in bucketpaths"
                :key="item.bucketname"
                :label="item.bucketname"
                :value="item.bucketname"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button @click="uploadresource">上传资料</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-col :span="24">
        <div class="leftpanel">
          <div>Oss路径:</div>
          <el-tree
            class="filter-tree"
            :data="pathdata"
            :props="pathprops"
            @node-click="pathselect"
            :expand-on-click-node="false"
            :render-content="pathcontext">
          </el-tree>
          <div class="desinfo"> *定义不同的路径等级与路径和客户</div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="selectuppathtitle" :visible.sync="dialogorVisible">
      <div class="showpcinfo">
        <el-form  label-width="150px">
          <MUpLoadFile ref="upfile" @upok="upmok" ifallfile :ifshowfile="ifshowfile" :ifupload="ifupload" :curfilepath="curfilepath" :bucketpath="bucketpath1"></MUpLoadFile>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import Utils from '../../util/utils'
import MUpLoadFile from '../upload/MUpLoadFile'
var OSS = require('ali-oss')
Vue.prototype.$http = axios
var that
export default {
  name: 'OssResource',
  components: {
    MUpLoadFile
  },
  data () {
    return {
      osspath: [{
        value: '1',
        label: 'Images'
      }, {
        value: '12',
        label: 'Brands'
      }],
      resourcetype: [{
        value: '0',
        label: '所有类型'
      }, {
        value: '1',
        label: '图片'
      }, {
        value: '2',
        label: '视频'
      }, {
        value: '3',
        label: '轮播图'
      }],
      pathdata: [],
      pathprops: {
        children: 'Children',
        label: 'path'
      },
      osspathname: '',
      resourcename: '',
      selectpathid: '',
      cursourceid: '',
      selectsubdata: [],
      bucketpaths: [],
      bucketpath: '',
      selecteditpathid: '',
      ossresourcedata: [],
      changepathid: '',
      selectuppathtitle: '',
      selectuppath: '',
      upparams: '',
      dialogorVisible: false,
      khid: '',
      uploadUrl: '',
      uploadFileLength: 0,
      uploadFileSuccess: 0,
      uploadFileNames: [],
      uploadFileName: [],
      fileList: [],
      files: 100,
      uploadHeaders: {
        authorization: ''
      },
      uppercent: 0,
      disabled: false,
      ifshowfile:false, // 上传页面参数： 是否显示文件
      curfilepath: '', // 上传页面参数： 当前选中图标文件路径
      ifimg: false, // 上传页面参数： 上传方式是否设定为 图片模式
      ifupload: false, // 上传页面参数： 是否显示上传参数
      bucketpath1: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listbucket',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var bmlist = JSON.parse(res.data.data)
            var bmdata = []
            for (var j = 0; j < bmlist.length; j++) {
              var stmp = bmlist[j]
              let datatmp = {
                bucketname: stmp
              }
              bmdata.push(datatmp)
            }
            that.bucketpaths = bmdata
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    pathcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.path}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.path_edit(node, data)}> </i>
          </span>
        </span>
      )
    },
    bucketchange () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketpath
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              var treedata
              treedata = {
                path: arrdatas[i],
                Children: []
              }
              treedatas.push(treedata)
            }
            that.pathdata = treedatas
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    pathchange (value) {
      console.log(value)
      this.selectpathid = value
      var qdata = {
        id: {Int64: parseInt(this.selectpathid), Valid: true},
        cusid: 19
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/gorpt',
        method: 'post',
        data: qdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.pathdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    OnOssResourceError (res) {
      console.log(res)
    },
    OnOssResourceSuccess (res, file, fileList) {
      if (res.success) {
        var ossnametmp = ''
        if (that.resourcename === '3') {
          ossnametmp = '轮播图'
        } else if (that.resourcename === '4') {
          that.resourcename = '2'
        }
        var data = {
          pathid: parseInt(that.cursourceid),
          rtypeid: parseInt(that.resourcename),
          ossname: {String: ossnametmp, Valid: true},
          ossurl: {String: res.data[0].osspath, Valid: true},
          cusid: parseInt(19)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/website/aauor',
          method: 'post',
          data: data,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '添加完毕'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        console.log(data)
      }
    },
    BeforeOssResourceUpload (file) {
    },
    resourcetypechange (value) {
      console.log(value)
      that.resourcename = value
      var qstr
      if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
        qstr = 'pathid =' + this.selecteditpathid
      } else {
        qstr = 'pathid =' + this.selecteditpathid + ' and rtypeid=' + that.resourcename
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qor',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.ossresourcedata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    path_edit (node, data) {
      console.log(data)
      this.selecteditpathid = data.id
      this.cursourceid = data.id
      if (node.level === 1) {
        this.selectuppath = data.path
      } else if (node.level === 2) {
        this.selectuppath = node.parent.data.path + '/' + node.data.path
      } else if (node.level === 3) {
        this.selectuppath = node.parent.parent.data.path + '/' + node.parent.data.path + '/' + node.data.path
      } else if (node.level === 4) {
        this.selectuppath = node.parent.parent.parent.data.path + '/' + node.parent.parent.data.path + '/' + node.parent.data.path + '/' + node.data.path
      }
      var qstr
      if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
        qstr = 'pathid =' + this.selecteditpathid
      } else {
        qstr = 'pathid =' + this.selecteditpathid + ' and rtypeid=' + that.resourcename
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qor',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.ossresourcedata = JSON.parse(res.data.data)
            that.selectsubdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    path_remove (node, data) {},
    removeresource (index1, data1) {
      console.log('开始删除')
      var data = data1[index1]
      var idstr = 'id =' + data.id.Int64
      console.log(idstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dor',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              var qstr
              if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
                qstr = 'pathid =' + that.selecteditpathid
              } else {
                qstr = 'pathid =' + that.selecteditpathid + ' and rtypeid=' + that.resourcename
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/website/qor',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.ossresourcedata = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '删除成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changepath () {
      if (that.changepathid === '' || that.changepathid === null) {
        that.$message({
          type: 'info',
          message: '需要填写变更路径ID'
        })
      } else {
        var tmplist = []
        for (var index in that.selectsubdata) {
          var subdata = that.selectsubdata[index]
          console.log(subdata)
          var data = {
            id: {Int64: parseInt(subdata.id.Int64), Valid: true},
            pathid: parseInt(that.changepathid),
            rtypeid: parseInt(subdata.rtypeid),
            ossname: {String: subdata.ossname.String, Valid: true},
            ossurl: {String: subdata.ossurl.String, Valid: true},
            cusid: parseInt(subdata.cusid)
          }
          tmplist.push(data)
        }
        console.log(tmplist)
        that.$http({
          url: 'https://api.sqnetsoft.cn/website/paauor',
          method: 'post',
          data: tmplist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更换完毕'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    pathselect (data, node) {
      console.log(data.path)
      this.selectpathdata = data
      this.selectpathnode = node
      that.selectuppath = data.path
      that.bucketpath1 = data.path.substring(0, data.path.lastIndexOf('/'));
      that.selectuppathtitle = '上传资料到路径：' + data.path
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketpath,
          bucketpath: {String: data.path, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              if (data.path !== arrdatas[i]) {
                var treedata
                treedata = {
                  path: arrdatas[i],
                  Children: []
                }
                treedatas.push(treedata)
              }
            }
            data.Children = treedatas
            node.expanded = true
            console.log(node)
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    nodeclick (data) {
      this.selecteditpathid = data.id
      this.cursourceid = data.id
      var qstr
      if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
        qstr = 'pathid =' + this.selecteditpathid
      } else {
        qstr = 'pathid =' + this.selecteditpathid + ' and rtypeid=' + that.resourcename
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/qor',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.ossresourcedata = JSON.parse(res.data.data)
            that.selectsubdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    uploadresource () {
      console.log(that.selectuppath)
      if (that.selectuppath || that.selectuppath !== '') {
        this.dialogorVisible = true
        this.upparams = {
          bucketname: 'sqtech',
          bucketpath: that.selectuppath
        }
      } else {
        that.$message({
          type: 'info',
          message: '请选择上传路径!'
        })
      }
    },
    pldel () {
      var idlist = []
      for (var index in this.$refs.osspathresource.selection) {
        var resource = this.$refs.osspathresource.selection[index]
        idlist.push(resource.id.Int64)
        console.log(resource.id.Int64)
      }
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/website/dor',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              var qstr
              if (that.resourcename === '' || that.resourcename === null || that.resourcename === '0') {
                qstr = 'pathid =' + that.selecteditpathid
              } else {
                qstr = 'pathid =' + that.selecteditpathid + ' and rtypeid=' + that.resourcename
              }
              that.$http({
                url: 'https://api.sqnetsoft.cn/website/qor',
                method: 'post',
                data: {
                  whereinfo: {String: qstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.ossresourcedata = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '删除成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },
    upmok (curpath,fileList) {
      window.console.log(fileList)
    },
    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIK44bzZpLz0As',
          accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
          bucket: 'wyzb1'
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectuppath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (file) {
      console.log(file)
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style lang="css">
  .querypanel {
    margin-top: 10px;
    border: 1px solid #ebebeb;
    padding: 40px;
    border-radius: 3px;
    transition: .2s;
  }
  .querypanel .el-form-item {
    margin-bottom: 15px;
  }
  .tabcard {
    padding: 20px;
  }
  .rightpanel {
    padding-left: 30px;
  }
  .opicon{
    padding-left: 5px;
  }
  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 80%;
  }
  .el-dialog__body {
    margin: 10px 20px 10px 20px;
    padding: 20px 30px;
    color: #f1f1f1;
    line-height: 24px;
    font-size: 14px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
  }

  .el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item1 {
    margin-bottom: 0px;
  }

  .el-form-item__label {
    text-align: left;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #5a5e66;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__footer {
    padding: 10px 10px 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__header {
    padding: 15px 15px 10px;
    background-color: #0d8ddb;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #f0f0f0;
  }

  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
    box-sizing: border-box;
    width: 80%;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/oss/OssResource.vue